import React, { Component } from 'react'
import { Popup, Form } from 'devextreme-react'
import httpRequest from 'plugin/httprequest'
import { custodies } from 'dataSource/lookup'

class LacakKlaimDetail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formData: {},
    }

    this.PopupRef = React.createRef()
    this.formRef = React.createRef()

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Tutup',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]

    this.formItems = [
      {
        itemType: 'group',
        colCount: 1,
        caption: 'PENGAJUAN',
        items: [
          {
            dataField: 'entryTipe',
            label: {
              text: 'Dikirim Oleh',
            },
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
            },
          },
          {
            dataField: 'sentDate',
            label: {
              text: 'Tanggal Kirim',
            },
            editorType: 'dxDateBox',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
              displayFormat: 'dd MMM yyyy',
              useMaskBehavior: true,
              width: '100%',
              openOnFieldClick: true,
            },
          },
        ],
      },
      {
        itemType: 'group',
        colCount: 1,
        caption: 'PEMERIKSAAN HRD',
        items: [
          {
            dataField: 'hrName',
            label: {
              text: 'Nama Pemeriksa',
            },
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
            },
          },
          {
            dataField: 'hrApprove',
            label: {
              text: 'Hasil Pemeriksaan',
            },
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
            },
          },
          {
            dataField: 'hrNote',
            label: {
              text: 'Catatan Pemeriksaan',
            },
            editorType: 'dxTextArea',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
                style: 'height: 120px !important',
              },
            },
          },
        ],
      },
      {
        itemType: 'group',
        colCount: 1,
        caption: 'PEMERIKSAAN DPLK',
        items: [
          {
            dataField: 'verificationBy',
            label: {
              text: 'Nama Pemeriksa',
            },
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
            },
          },
          {
            dataField: 'verificationAct',
            label: {
              text: 'Hasil Pemeriksaan',
            },
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
            },
          },
          {
            dataField: 'verificationNote',
            label: {
              text: 'Catatan Pemeriksaan',
            },
            editorType: 'dxTextArea',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
                style: 'height: 120px !important',
              },
            },
          },
        ],
      },
      {
        itemType: 'group',
        colCount: 1,
        caption: 'PERSETUJUAN DPLK',
        items: [
          {
            dataField: 'approvalBy',
            label: {
              text: 'Nama Pemeriksa',
            },
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
            },
          },
          {
            dataField: 'approvalAct',
            label: {
              text: 'Hasil Pemeriksaan',
            },
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
            },
          },
          {
            dataField: 'approvalNote',
            label: {
              text: 'Catatan Pemeriksaan',
            },
            editorType: 'dxTextArea',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
                style: 'height: 120px !important',
              },
            },
          },
        ],
      },

      {
        itemType: 'group',
        colCount: 1,
        caption: 'INSTRUKSI PEMBAYARAN',
        items: [
          {
            dataField: 'custodyId',
            label: {
              text: 'Bank Custody',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
              dataSource: custodies(this.props.store),
              valueExpr: 'id',
              displayExpr: 'custodyName',
              searchEnabled: true,
              deferRendering: false,
            },
          },
          {
            dataField: 'instruksiDate',
            label: {
              text: 'Tanggal Kirim Instruksi',
            },
            editorType: 'dxDateBox',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
              },
              displayFormat: 'dd MMM yyyy',
              useMaskBehavior: true,
              width: '100%',
              openOnFieldClick: true,
            },
          },
        ],
      },
    ]
  }

  show = () => {
    this.setState({
      popupVisible: true,
    })
  }

  hide = () => {
    this.setState({
      popupVisible: false,
      formData: {},
    })
  }

  retrieveData = async (klaimId) => {
    let dataKlaim = await httpRequest(
      process.env.REACT_APP_BACKEND_CORE,
      this.props.store,
      `wp/claim-detail/${klaimId}`
    )

    if (dataKlaim) {
      dataKlaim.hrApprove = dataKlaim.hrApprove ? 'Approved' : '-'
      dataKlaim.verificationAct = dataKlaim.verificationAct ? 'Approved' : '-'
      dataKlaim.approvalAct = dataKlaim.approvalAct ? 'Approved' : '-'
      this.setState({
        formData: dataKlaim,
      })
    }
  }

  render() {
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={false}
        showTitle={true}
        title="Lacak Transaksi"
        width={700}
        height={700}
        toolbarItems={this.PopupToolbarItem}
        ref={this.PopupRef}
      >
        <Form
          ref={this.formRef}
          colCount={1}
          id={'lacakKlaim'}
          formData={this.state.formData}
          items={this.formItems}
          labelLocation="left"
          scrollingEnabled={true}
          readOnly={true}
        />
      </Popup>
    )
  }
}

export default LacakKlaimDetail
